import { render, staticRenderFns } from "./ItemDiscountForWholesale.vue?vue&type=template&id=785ba6e8&scoped=true&"
import script from "./ItemDiscountForWholesale.vue?vue&type=script&lang=js&"
export * from "./ItemDiscountForWholesale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785ba6e8",
  null
  
)

export default component.exports